import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Pageable } from 'app/interfaces/Pageable/pageable';
import { environment } from 'environments/environment';
import { TimezoneService } from 'app/utils/timezone.service';
import { TeusCalculo } from 'app/interfaces/teusCalculo';
import { HomeProcessoVendedor } from 'app/interfaces/home-processo-vendedor';
import { ProcessoTrFiltro } from 'app/interfaces/processo-tr-filtro';
import { ProcessoTr } from 'app/interfaces/processo-tr';
import { ProcessoTrUpdateAbas } from 'app/interfaces/processo-tr-update-abas';
import { ProcessoTrEquipamento } from 'app/interfaces/processo-tr-equipamento';
import { ProcessoTrAuditoriaFinal } from 'app/interfaces/processo-tr-auditoria-final';
import { ProcessoTrVolume } from 'app/interfaces/processo-tr-volume';
import { ProcessoTrControleBooking } from 'app/interfaces/processo-tr-controle-booking';
import { ProcessoTrDataFaturamento } from 'app/interfaces/processo-tr-data-faturamento';
import { ProcessoTrLucratividade } from 'app/interfaces/processo-tr-lucratividade';
import { ProcessoTrCancelar } from 'app/interfaces/processo-tr-cancelar';
import { ProcessoTrInfoParaBuscarTarifario } from 'app/interfaces/processo-tr-info-para-buscar-tarifario';
import { ProcessoTrUpdateAbaObservacoes } from 'app/interfaces/processo-tr-update-aba-observacoes';
import { ProcessoTrUpdateAbaProgramacao } from 'app/interfaces/processo-tr-update-aba-programacao';
import { ProcessoTrUpdateAbaCarga } from 'app/interfaces/processo-tr-update-aba-carga';
import { ProcessoTrUpdateAbaDetalhes } from 'app/interfaces/processo-tr-update-aba-detalhes';
import { ProcessoTrResumoCusto } from 'app/interfaces/processo-tr-resumo-custo';
import { AlteracaoStatusProcessoTr } from 'app/interfaces/alteracaoStatusProcessoTr';
import { HomeProcesso } from 'app/interfaces/home-processo';
import { ProcessoTrValidacao } from 'app/interfaces/processo-tr-validacao';
import { ProcessoTrValidacaoForm } from 'app/interfaces/processo-tr-validacao-form';
import { ProcessoTrUpdateAbaGeneralidades } from 'app/interfaces/processo-tr-update-aba-generalidades';
import { ProcessoTrUpdateAbaDocumental } from 'app/interfaces/processo-tr-update-aba-documental';
import { CteDocumental } from 'app/interfaces/cte-documental';
import { Observable } from 'rxjs';
import { MdfeDocumental } from 'app/interfaces/mdfe-documental';
import { ConsultaRotasApi } from 'app/interfaces/consulta-api-rotas';
import { Moeda } from 'app/interfaces/moeda';
import { ProcessoTrNotaFiscal } from 'app/interfaces/processo-tr-nota-fiscal';
import { MotivoDesbloqueioProcessoTr } from 'app/interfaces/enum/motivo-desbloqueio-processo-tr.enum';
import { ProcessoTrDesbloqueio } from 'app/interfaces/processo-tr-desbloqueio';

export interface ResumoDashboardTr {
  processosPorStatus: HomeProcesso[];
  romaneios: {
    emitidosHoje: number;
    totalEmitidos: number;
  };
}

@Injectable({
  providedIn: 'root',
})
export class ProcessoTrHttpService {
  constructor(
    private _http: HttpClient,
    private _timezoneService: TimezoneService
  ) {}

  /**
   * Função para buscar todos 1processos;
   * @param nome
   * @param page
   * @returns
   */
  getAll({ filtro, size = 200, page = 0, sort = '' }: { filtro: ProcessoTrFiltro; size?: number; page?: number; sort?: string }) {
    return this._http.post<Pageable>(`${environment.apiUrl}/api/process-tr/v1/processos-tr?sort=${sort}&size=${size}&page=${page}`, filtro);
  }

  /**
   * Função para buscar o processo pelo id;
   * @param id
   * @returns
   */
  getById(id: number) {
    return this._http.get<ProcessoTr>(`${environment.apiUrl}/api/process-tr/v1/processos-tr/${id}`);
  }

  /**
   * Função para buscar o header do processo pelo id;
   * @param id
   * @returns
   */
  getHeaderById(id: number) {
    return this._http.get<ProcessoTr>(`${environment.apiUrl}/api/process-tr/v1/processos-tr/header/${id}`);
  }

  /**
   * Função para salvar um processo;
   * @param processo
   * @returns
   */
  salvar(processo: ProcessoTr) {
    return this._http.post<ProcessoTr>(`${environment.apiUrl}/api/process-tr/v1/processos-tr`, processo);
  }

  /**
   * Função para atualizar um processo;
   * @param processo
   * @returns
   */
  updateGrupos(processoTrId: number, processoUpdateAbas: ProcessoTrUpdateAbas, atualizarCustos: boolean, desbloqueioId?: number) {
    const paramDesbloqueio = desbloqueioId ? `&desbloqueioId=${desbloqueioId}` : '';
    return this._http.put<boolean>(
      `${environment.apiUrl}/api/process-tr/v1/processos-tr/${processoTrId}?atualizarCustos=${atualizarCustos}${paramDesbloqueio}`,
      processoUpdateAbas
    );
  }

  updateHeader(processo: ProcessoTr, desbloqueioId?: number) {
    const paramDesbloqueio = desbloqueioId ? `?desbloqueioId=${desbloqueioId}` : '';
    return this._http.put<ProcessoTr>(
      `${environment.apiUrl}/api/process-tr/v1/processos-tr/header/${processo.processoTrId}${paramDesbloqueio}`,
      processo
    );
  }

  /**
   * Delete um registro;
   * @param id
   * @returns
   */
  delete(id: number) {
    return this._http.delete<boolean>(`${environment.apiUrl}/api/process-tr/v1/processos-tr/${id}`);
  }

  /**
   * Atualizar resumo de custos
   * @param processoResumoCusto
   */
  updateResumoCustosByProcessoId(processoTrId: number) {
    return this._http.put<ProcessoTrResumoCusto>(
      `${environment.apiUrl}/api/process-tr/v1/processos-tr/resumo-custos-by-processo-id/${processoTrId}`,
      null
    );
  }

  /**
   * Função para validar Campos dos Custos pelo id do processo;
   * @param processoTrId
   * @returns
   */
  validaCamposCustosByProcessoId(processoTrId: number) {
    return this._http.get<boolean>(`${environment.apiUrl}/api/process-tr/v1/processos-tr/valida-campos-custos-by-processo/${processoTrId}`);
  }

  /**
   * Função para buscar o resumo dos custos pelo id do processo;
   * @param processoTrId
   * @returns
   */
  getResumoCustosByProcessoId(processoTrId: number) {
    return this._http.get<ProcessoTrResumoCusto>(`${environment.apiUrl}/api/process-tr/v1/processos-tr/resumo-custos/${processoTrId}`);
  }

  /**
   * Função para pegar valores da aba específicada
   * @param processoTrId
   */
  getAbaDetalhes(processoTrId: number) {
    return this._http.get<ProcessoTrUpdateAbaDetalhes>(`${environment.apiUrl}/api/process-tr/v1/processos-tr/detalhes/${processoTrId}`);
  }

  getTipoOperacaoFiscal(origemId: number, destinoId: number) {
    return this._http.get<string>(
      `${environment.apiUrl}/api/process-tr/v1/processos-tr/tipo-operacao-fiscal?origemId=${origemId}&destinoId=${destinoId}`
    );
  }

  /**
   * Função para pegar valores da aba específicada
   * @param processoTrId
   */
  getAbaCarga(processoTrId: number) {
    return this._http.get<ProcessoTrUpdateAbaCarga>(`${environment.apiUrl}/api/process-tr/v1/processos-tr/carga/${processoTrId}`);
  }

  /**
   * Função para pegar valores da aba específicada
   * @param processoTrId
   */
  getAbaProgramacao(processoTrId: number) {
    return this._http.get<ProcessoTrUpdateAbaProgramacao>(`${environment.apiUrl}/api/process-tr/v1/processos-tr/programacao/${processoTrId}`);
  }

  /**
   * Função para pegar valores da aba específicada
   * @param processoTrId
   */
  getAbaObservacoes(processoTrId: number) {
    return this._http.get<ProcessoTrUpdateAbaObservacoes>(`${environment.apiUrl}/api/process-tr/v1/processos-tr/observacoes/${processoTrId}`);
  }

  /**
   * Função para pegar informações para incluir no tarifário
   * @param processoTrId
   */
  getInformacoesParaIncluirTarifario(processoTrId: number) {
    return this._http.get<ProcessoTrInfoParaBuscarTarifario>(
      `${environment.apiUrl}/api/process-tr/v1/processos-tr/informacoes-tarifario/${processoTrId}`
    );
  }

  getAllAudit(processoTrId: number, page: number, email: string, dataInicial: Date, dataFinal: Date, tipoAuditoria: string) {
    let params = {
      size: 10,
      page: page,
      dataInicial: dataInicial ? this._timezoneService.utcToUserString(dataInicial) : '',
      dataFinal: dataFinal ? this._timezoneService.utcToUserString(dataFinal) : '',
      email: email ? email : '',
      tipoAuditoria: tipoAuditoria ? tipoAuditoria : '',
    };

    return this._http.get<Pageable>(`${environment.apiUrl}/api/process-tr/v1/processos-tr-auditorias/${processoTrId}`, { params: params });
  }

  /**
   * @param parceiroClienteId
   * @returns
   */
  atualizaAllContatosProcesso(processoTrId: number) {
    return this._http.put<boolean>(`${environment.apiUrl}/api/process-tr/v1/processos-tr/atualiza-all-contatos-by-parceiro/${processoTrId}`, null);
  }

  findProcessosByCodigo(codigoProcesso: string) {
    return this._http.get<ProcessoTr[]>(
      `${environment.apiUrl}/api/process-tr/v1/processos-tr/find-processos-by-codigo?codigoProcesso=${codigoProcesso}`
    );
  }

  salvaNCMsProcesso(ncms: string, processoTrId: number) {
    return this._http.put<boolean>(`${environment.apiUrl}/api/process-tr/v1/processos-tr/salvar-ncms-processo/${processoTrId}?ncms=${ncms}`, null);
  }

  cancelar(justificativa: ProcessoTrCancelar) {
    return this._http.post<boolean>(`${environment.apiUrl}/api/process-tr/v1/processos-tr/cancelar`, justificativa);
  }

  getInformacaoGraficoLucratividade(processoTrId: number, dataInicial?: string, dataFinal?: string) {
    let params: any = {};

    if (dataInicial && dataFinal) {
      params.dataInicial = dataInicial;
      params.dataFinal = dataFinal;
    }
    return this._http.get<ProcessoTrLucratividade[]>(`${environment.apiUrl}/api/process-tr/v1/processo-tr-historico-lucratividade/${processoTrId}`, {
      params,
    });
  }

  getAuditComparacao(processoTrId: number, rev: number) {
    return this._http.get<any[]>(`${environment.apiUrl}/api/process-tr/v1/processos-tr-auditorias/comparacao-audit/${processoTrId}?rev=${rev}`);
  }

  /**
   *
   */
  getDataFaturamentoProcesso(processoTrId: number) {
    return this._http.get<ProcessoTrDataFaturamento>(
      `${environment.apiUrl}/api/process-tr/v1/processos-tr/get-processo-data-faturamento/${processoTrId}`
    );
  }

  getTeus(teus: TeusCalculo[]) {
    return this._http.post<number>(`${environment.apiUrl}/api/process-tr/v1/oportunidade-oferta-tr-equipamentos/get-teus`, teus);
  }

  findProcessosByCodigoControleBooking(codigoProcesso: string) {
    return this._http.get<ProcessoTrControleBooking[]>(
      `${environment.apiUrl}/api/process-tr/v1/processos-tr/find-processos-by-codigo-controle-booking?codigoProcesso=${codigoProcesso}`
    );
  }

  getResultadoCalculoCubagem(volume: ProcessoTrVolume) {
    return this._http.post<ProcessoTrVolume>(`${environment.apiUrl}/api/process-tr/v1/oportunidade-ofertas-tr/calcular-cubagem`, volume);
  }

  updateEquipamento(equipamentoId: number, equipamento: ProcessoTrEquipamento) {
    return this._http.put<ProcessoTrEquipamento>(`${environment.apiUrl}/api/process-tr/v1/processo-tr-equipamentos/${equipamentoId}`, equipamento);
  }

  getAuditoriaFinal(processoTrId: number) {
    return this._http.get<ProcessoTrAuditoriaFinal>(`${environment.apiUrl}/api/process-tr/v1/processos-tr/processo-auditoria-final/${processoTrId}`);
  }

  updateAuditoriaFinal(processoAuditoriaFinal: ProcessoTrAuditoriaFinal) {
    return this._http.post<ProcessoTrAuditoriaFinal>(
      `${environment.apiUrl}/api/process-tr/v1/processos-tr/processo-auditoria-final/${processoAuditoriaFinal.processoTrId}`,
      processoAuditoriaFinal
    );
  }

  getInformacaoGraficoProcessoVendedor(vendedorId: number, dataInicial?: string, dataFinal?: string) {
    const params: any = { vendedorId };

    if (dataInicial) params.dataInicial = dataInicial;
    if (dataFinal) params.dataFinal = dataFinal;

    return this._http.get<HomeProcessoVendedor[]>(`${environment.apiUrl}/api/process-tr/v1/processos-tr/resumo-processos-by-vendedor`, { params });
  }

  getAllProcessosParaConsolidar(page: number = 0, sort?: string, codigoProcesso?: string, ciaAereaId?: number) {
    const params = {
      size: 10,
      page: page || '',
      sort: sort || '',
      codigoProcesso: codigoProcesso || '',
      ciaAereaId: ciaAereaId || '',
    };

    return this._http.get<Pageable>(`${environment.apiUrl}/api/process-tr/v1/processos-tr/find-all-para-consolidar`, { params });
  }

  consolidarProcessos(parceiroNegocioCompanhiaAereaEstoqueId: number, processos: ProcessoTr[]) {
    const procesosParaConsolidar = Array.from(
      processos.map(p => {
        return { codigoProcesso: p.codigoProcesso, processoTrId: p.processoTrId };
      })
    );

    return this._http.put<Boolean>(
      `${environment.apiUrl}/api/process-tr/v1/processos-tr/consolidar?parceiroNegocioCompanhiaAereaEstoqueId=${parceiroNegocioCompanhiaAereaEstoqueId}`,
      procesosParaConsolidar
    );
  }

  /**
   * Busca a lista de revisões de auditoria para os volumes de um processo
   */
  getAllAuditVolumeByProcesso(processoTrId: number, page: number, email: string, dataInicial: Date, dataFinal: Date, tipoAuditoria: string) {
    let params = {
      size: 10,
      page: page,
      dataInicial: dataInicial ? this._timezoneService.utcToUserString(dataInicial) : '',
      dataFinal: dataFinal ? this._timezoneService.utcToUserString(dataFinal) : '',
      email: email ? email : '',
      tipoAuditoria: tipoAuditoria ? tipoAuditoria : '',
    };

    return this._http.get<Pageable>(`${environment.apiUrl}/api/process-tr/v1/processo-tr-volumes-auditorias/${processoTrId}`, { params: params });
  }

  /**
   * Busca a comparação de uma revisão específica de um volume
   */
  getVolumeAuditComparacao(processoVolumeId: number, rev: number) {
    return this._http.get<any[]>(
      `${environment.apiUrl}/api/process-tr/v1/processo-tr-volumes-auditorias/comparacao-audit/${processoVolumeId}?rev=${rev}`
    );
  }

  getAllAuditEquipamentoByProcesso(processoTrId: number, page: number, email: string, dataInicial: Date, dataFinal: Date, tipoAuditoria: string) {
    let params = {
      size: 10,
      page: page,
      dataInicial: dataInicial ? this._timezoneService.utcToUserString(dataInicial) : '',
      dataFinal: dataFinal ? this._timezoneService.utcToUserString(dataFinal) : '',
      email: email ? email : '',
      tipoAuditoria: tipoAuditoria ? tipoAuditoria : '',
    };

    return this._http.get<Pageable>(`${environment.apiUrl}/api/process-tr/v1/processo-tr-equipamentos-auditorias/${processoTrId}`, {
      params: params,
    });
  }

  getEquipamentoAuditComparacao(id: number, rev: number) {
    return this._http.get<any[]>(`${environment.apiUrl}/api/process-tr/v1/processo-tr-equipamentos-auditorias/comparacao-audit/${id}?rev=${rev}`);
  }

  getCodigoProcessoByHouse(house: string) {
    return this._http.get<string[]>(`${environment.apiUrl}/api/process-tr/v1/processos-tr/codigo-processo-by-house/${house}`);
  }

  isTarifarioDentroFaixaPeso(processo: { processoTrId: number; produto: string; pesoTaxadoVolumes: number; destinoCargaId: number }) {
    return this._http.post<boolean>(`${environment.apiUrl}/api/process-tr/v1/processos-tr/verificar-faixa-peso-tarifario`, processo);
  }

  integrarProcessoComoHouse(house: string, processoTrId: number, recintoAlfandegadoId: number) {
    let params = {
      house,
      recintoAlfandegadoId,
    };

    return this._http.put<ProcessoTr>(`${environment.apiUrl}/api/process-tr/v1/siscomex-api/integrar-processo-como-house/${processoTrId}`, null, {
      params,
    });
  }

  removerProcessoComoHouse(house: string, processoTrId: number) {
    let params = {
      house,
    };

    return this._http.delete<ProcessoTr>(`${environment.apiUrl}/api/process-tr/v1/siscomex-api/remover-processo-como-house/${processoTrId}`, {
      params,
    });
  }

  alterarStatus(request: AlteracaoStatusProcessoTr) {
    return this._http.put<void>(`${environment.apiUrl}/api/process-tr/v1/processos-tr/${request.processoTrId}/status`, request);
  }

  reaplicarImpostos(processoTrId: number) {
    return this._http.post<void>(`${environment.apiUrl}/api/process-tr/v1/processos-tr-impostos/reaplicar`, {}, {
      params: { processoTrId }
    });
  }

  findValidacoes(processoTrId: number) {
    return this._http.get<ProcessoTrValidacao[]>(`${environment.apiUrl}/api/process-tr/v1/processos-tr/${processoTrId}/validacoes`);
  }

  salvarValidacao(processoTrId: number, form: ProcessoTrValidacaoForm) {
    return this._http.post<ProcessoTrValidacao>(`${environment.apiUrl}/api/process-tr/v1/processos-tr/${processoTrId}/validacoes`, form);
  }

  atualizarValidacao(processoTrId: number, processoTrValidacaoId: number, form: ProcessoTrValidacaoForm) {
    return this._http.put<ProcessoTrValidacao>(
      `${environment.apiUrl}/api/process-tr/v1/processos-tr/${processoTrId}/validacoes/${processoTrValidacaoId}`,
      form
    );
  }

  getInformacaoGraficoProcessoRodoviario(dataInicial?: string, dataFinal?: string) {
    const params: any = { incluirRomaneios: true };

    if (dataInicial) params.dataInicial = dataInicial;
    if (dataFinal) params.dataFinal = dataFinal;

    return this._http.get<ResumoDashboardTr>(`${environment.apiUrl}/api/process-tr/v1/processos-tr/resumo-processos`, { params });
  }

  /**
   * Função para pegar valores da aba específicada
   * @param processoTrId
   */
  getAbaGeneralidades(processoTrId: number) {
    return this._http.get<ProcessoTrUpdateAbaGeneralidades>(`${environment.apiUrl}/api/process-tr/v1/processos-tr/generalidades/${processoTrId}`);
  }

  /**
   * Função para emitir romaneio
   * @param processoTrId
   */
  emitirRomaneio(processoTrId: number) {
    return this._http.put<Boolean>(`${environment.apiUrl}/api/process-tr/v1/processos-tr/${processoTrId}/emitir-romaneio`, {});
  }

  getMotivosDesbloqueio(processoTrId: number) {
    return this._http.get<MotivoDesbloqueioProcessoTr[]>(`${environment.apiUrl}/api/process-tr/v1/processos-tr/${processoTrId}/desbloqueio/motivos`);
  }

  desbloquear(processoTrId: number, motivo: MotivoDesbloqueioProcessoTr) {
    return this._http.post<ProcessoTrDesbloqueio>(`${environment.apiUrl}/api/process-tr/v1/processos-tr/${processoTrId}/desbloqueio`, {
      motivo,
    });
  }

  bloquear(processoTrId: number, desbloqueioId: number) {
    return this._http.put<boolean>(`${environment.apiUrl}/api/process-tr/v1/processos-tr/${processoTrId}/desbloqueio/${desbloqueioId}/bloquear`, {});
  }

  getAbaDocumental(processoTrId: number) {
    return this._http.get<ProcessoTrUpdateAbaDocumental>(`${environment.apiUrl}/api/process-tr/v1/processos-tr/documental/${processoTrId}`);
  }

  getCteDocumental(processoTrId: number): Observable<CteDocumental> {
    return this._http.get<CteDocumental>(`${environment.apiUrl}/api/process-tr/v1/cte/documental/${processoTrId}`);
  }

  getMdfeDocumental(processoTrId: number): Observable<MdfeDocumental> {
    return this._http.get<MdfeDocumental>(`${environment.apiUrl}/api/process-tr/v1/mdfe/documental/${processoTrId}`);
  }

  listarCtesSubcontratacao(processoTrId: number) {
    return this._http.get<any[]>(`${environment.apiUrl}/api/process-tr/v1/processos-tr/${processoTrId}/ctes-subcontratacao`);
  }

  importarCtesSubcontratacao(processoTrId: number, arquivos: File[]) {
    const formData = new FormData();
    arquivos.forEach(arquivo => formData.append('arquivos', arquivo));
    return this._http.post<any[]>(`${environment.apiUrl}/api/process-tr/v1/processos-tr/${processoTrId}/ctes-subcontratacao/importar`, formData);
  }

  deletarCteSubcontratacao(processoTrId: number, cteSubcontratacaoId: number) {
    return this._http.delete<void>(`${environment.apiUrl}/api/process-tr/v1/processos-tr/${processoTrId}/ctes-subcontratacao/${cteSubcontratacaoId}`);
  }

  calculaTotalNotasEmBrl(notas: ProcessoTrNotaFiscal[]) {
    const body = notas.map(n => {
      const { moedaNf, valorNf } = n;
      return { moedaNf, valorNf };
    });

    return this._http.post<number>(`${environment.apiUrl}/api/process-tr/v1/processos-tr/calcula-valor-notas-em-brl`, body);
  }
}
